"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IR35_FILE_SUBTYPE = exports.IR35_STATUSES = exports.terminationReasonOptions = exports.terminationReasonLabels = exports.terminationReason = exports.noSalarySetLabel = exports.compensationPeriodicity = exports.compensationStatus = exports.contractStatusOptions = exports.contractStatusBadges = exports.contractStatusLabels = exports.contractStatus = exports.employmentIncompleteStatusSorted = exports.employmentActions = exports.employmentStatusOptions = exports.employmentStatusBadges = exports.employmentStatusDetails = exports.employmentStatusLabels = exports.employmentStatus = exports.employmentEligibilityOptions = exports.employmentTypeOptions = exports.employmentTypeLabels = exports.employmentTypeKeys = exports.employmentTypeForRoute = exports.employmentType = exports.contractTypeLabels = exports.contractType = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _contractTypeLabels, _employmentTypeForRou, _employmentTypeLabels, _employmentStatusLabe, _employmentStatusDeta, _employmentStatusBadg, _contractStatusLabels, _contractStatusBadges, _terminationReasonLab;

var contractType = {
  FULL_TIME: 'full_time',
  CONTRACTOR: 'contractor'
};
exports.contractType = contractType;
var contractTypeLabels = (_contractTypeLabels = {}, (0, _defineProperty2["default"])(_contractTypeLabels, contractType.FULL_TIME, 'Employee'), (0, _defineProperty2["default"])(_contractTypeLabels, contractType.CONTRACTOR, 'Contractor'), _contractTypeLabels); // - - - - - - - - -

exports.contractTypeLabels = contractTypeLabels;
var employmentType = {
  FULL_TIME: 'full_time',
  CONTRACTOR: 'contractor'
};
exports.employmentType = employmentType;
var employmentTypeForRoute = (_employmentTypeForRou = {}, (0, _defineProperty2["default"])(_employmentTypeForRou, employmentType.FULL_TIME, 'full_time'), (0, _defineProperty2["default"])(_employmentTypeForRou, employmentType.CONTRACTOR, 'contractor'), _employmentTypeForRou);
exports.employmentTypeForRoute = employmentTypeForRoute;
var employmentTypeKeys = {
  full_time: employmentType.FULL_TIME,
  contractor: employmentType.CONTRACTOR
};
exports.employmentTypeKeys = employmentTypeKeys;
var employmentTypeLabels = (_employmentTypeLabels = {}, (0, _defineProperty2["default"])(_employmentTypeLabels, employmentType.FULL_TIME, 'Employee'), (0, _defineProperty2["default"])(_employmentTypeLabels, employmentType.CONTRACTOR, 'Contractor'), _employmentTypeLabels);
exports.employmentTypeLabels = employmentTypeLabels;
var employmentTypeOptions = [{
  value: employmentType.FULL_TIME,
  label: 'Employee'
}, {
  value: employmentType.CONTRACTOR,
  label: 'Contractor'
}]; // - - - - - - - - -

exports.employmentTypeOptions = employmentTypeOptions;
var employmentEligibilityOptions = {
  PERMANENT_RESIDENT: 'permanent_resident',
  WORK_PERMIT: 'work_permit',
  NO: 'no'
}; // - - - - - - - - -

exports.employmentEligibilityOptions = employmentEligibilityOptions;
var employmentStatus = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  CREATED: 'created',
  INITIATED: 'initiated',
  INVITED: 'invited',
  PENDING: 'pending',
  REVIEW: 'review',
  AWAITING_INVITATION: 'awaiting_invitation',
  DELETED: 'deleted',
  // Used to filter employees by status. It returns people that match one of the status:
  // created, initiated, invited, pending, awaiting_invitation or review.
  INCOMPLETE: 'incomplete'
};
exports.employmentStatus = employmentStatus;
var employmentStatusLabels = (_employmentStatusLabe = {}, (0, _defineProperty2["default"])(_employmentStatusLabe, employmentStatus.ACTIVE, 'Active'), (0, _defineProperty2["default"])(_employmentStatusLabe, employmentStatus.ARCHIVED, 'Archived'), (0, _defineProperty2["default"])(_employmentStatusLabe, employmentStatus.CREATED, 'Created'), (0, _defineProperty2["default"])(_employmentStatusLabe, employmentStatus.INITIATED, 'Initiated'), (0, _defineProperty2["default"])(_employmentStatusLabe, employmentStatus.INVITED, 'Invited'), (0, _defineProperty2["default"])(_employmentStatusLabe, employmentStatus.PENDING, 'Pending'), (0, _defineProperty2["default"])(_employmentStatusLabe, employmentStatus.REVIEW, 'Review'), (0, _defineProperty2["default"])(_employmentStatusLabe, employmentStatus.DELETED, 'Deleted'), (0, _defineProperty2["default"])(_employmentStatusLabe, employmentStatus.AWAITING_INVITATION, 'Awaiting invitation'), (0, _defineProperty2["default"])(_employmentStatusLabe, employmentStatus.INCOMPLETE, 'Incomplete (in onboarding)'), _employmentStatusLabe);
exports.employmentStatusLabels = employmentStatusLabels;
var employmentStatusDetails = (_employmentStatusDeta = {}, (0, _defineProperty2["default"])(_employmentStatusDeta, employmentStatus.CREATED, {
  description: "You need to complete new hire's details"
}), (0, _defineProperty2["default"])(_employmentStatusDeta, employmentStatus.AWAITING_INVITATION, {
  description: 'New hire details complete. Invite new hire to Remote'
}), (0, _defineProperty2["default"])(_employmentStatusDeta, employmentStatus.INVITED, {
  description: 'New hire has been invited to complete self-onboarding'
}), (0, _defineProperty2["default"])(_employmentStatusDeta, employmentStatus.INITIATED, {
  description: 'New hire is completing self-onboarding'
}), (0, _defineProperty2["default"])(_employmentStatusDeta, employmentStatus.PENDING, {
  description: 'Information needed. Remote is collecting this from the Hire'
}), (0, _defineProperty2["default"])(_employmentStatusDeta, employmentStatus.REVIEW, {
  description: 'Remote is creating and reviewing employment documentation with new hire'
}), _employmentStatusDeta);
exports.employmentStatusDetails = employmentStatusDetails;
var employmentStatusBadges = (_employmentStatusBadg = {}, (0, _defineProperty2["default"])(_employmentStatusBadg, employmentStatus.ACTIVE, 'active'), (0, _defineProperty2["default"])(_employmentStatusBadg, employmentStatus.INCOMPLETE, 'pending'), (0, _defineProperty2["default"])(_employmentStatusBadg, employmentStatus.ARCHIVED, 'inactive'), (0, _defineProperty2["default"])(_employmentStatusBadg, employmentStatus.CREATED, 'pending'), (0, _defineProperty2["default"])(_employmentStatusBadg, employmentStatus.INITIATED, 'pending'), (0, _defineProperty2["default"])(_employmentStatusBadg, employmentStatus.INVITED, 'pending'), (0, _defineProperty2["default"])(_employmentStatusBadg, employmentStatus.PENDING, 'pending'), (0, _defineProperty2["default"])(_employmentStatusBadg, employmentStatus.REVIEW, 'pending'), (0, _defineProperty2["default"])(_employmentStatusBadg, employmentStatus.DELETED, 'inactive'), (0, _defineProperty2["default"])(_employmentStatusBadg, employmentStatus.AWAITING_INVITATION, 'pending'), (0, _defineProperty2["default"])(_employmentStatusBadg, employmentStatus.INCOMPLETE, 'pending'), _employmentStatusBadg);
exports.employmentStatusBadges = employmentStatusBadges;
var employmentStatusOptions = [{
  value: employmentStatus.ACTIVE,
  label: employmentStatusLabels[employmentStatus.ACTIVE]
}, {
  value: employmentStatus.INCOMPLETE,
  label: employmentStatusLabels[employmentStatus.INCOMPLETE]
}, {
  value: employmentStatus.CREATED,
  label: employmentStatusLabels[employmentStatus.CREATED]
}, {
  value: employmentStatus.AWAITING_INVITATION,
  label: employmentStatusLabels[employmentStatus.AWAITING_INVITATION]
}, {
  value: employmentStatus.INVITED,
  label: employmentStatusLabels[employmentStatus.INVITED]
}, {
  value: employmentStatus.INITIATED,
  label: employmentStatusLabels[employmentStatus.INITIATED]
}, {
  value: employmentStatus.PENDING,
  label: employmentStatusLabels[employmentStatus.PENDING]
}, {
  value: employmentStatus.REVIEW,
  label: employmentStatusLabels[employmentStatus.REVIEW]
}, {
  value: employmentStatus.ARCHIVED,
  label: employmentStatusLabels[employmentStatus.ARCHIVED]
}, {
  value: employmentStatus.DELETED,
  label: employmentStatusLabels[employmentStatus.DELETED]
}];
exports.employmentStatusOptions = employmentStatusOptions;
var employmentActions = {
  REMOVE_HIRE: 'REMOVE_HIRE',
  SEND_INVITE: 'SEND_INVITE',
  RESEND_INVITE: 'RESEND_INVITE'
}; // - - - - - - - - -

exports.employmentActions = employmentActions;
var employmentIncompleteStatusSorted = [employmentStatus.CREATED, employmentStatus.AWAITING_INVITATION, employmentStatus.INVITED, employmentStatus.INITIATED, employmentStatus.PENDING, employmentStatus.REVIEW];
exports.employmentIncompleteStatusSorted = employmentIncompleteStatusSorted;
var contractStatus = {
  BOTH_PARTIES_SIGNED: 'both_parties_signed',
  DECLINED: 'declined',
  EMPLOYEE_SIGNED: 'employee_signed',
  EMPLOYER_SIGNED: 'employer_signed',
  ISSUED: 'issued',
  PENDING_EMPLOYEE_SIGNATURE: 'pending_employee_signature',
  PENDING_EMPLOYER_SIGNATURE: 'pending_employer_signature',
  TERMINATED: 'terminated'
};
exports.contractStatus = contractStatus;
var contractStatusLabels = (_contractStatusLabels = {}, (0, _defineProperty2["default"])(_contractStatusLabels, contractStatus.BOTH_PARTIES_SIGNED, 'Signed'), (0, _defineProperty2["default"])(_contractStatusLabels, contractStatus.DECLINED, 'Declined'), (0, _defineProperty2["default"])(_contractStatusLabels, contractStatus.EMPLOYEE_SIGNED, 'Signed by employee'), (0, _defineProperty2["default"])(_contractStatusLabels, contractStatus.EMPLOYER_SIGNED, 'Signed by customer'), (0, _defineProperty2["default"])(_contractStatusLabels, contractStatus.ISSUED, 'Awaiting signatures'), (0, _defineProperty2["default"])(_contractStatusLabels, contractStatus.PENDING_EMPLOYEE_SIGNATURE, 'Waiting for employee to sign'), (0, _defineProperty2["default"])(_contractStatusLabels, contractStatus.PENDING_EMPLOYER_SIGNATURE, 'Waiting for customer to sign'), (0, _defineProperty2["default"])(_contractStatusLabels, contractStatus.TERMINATED, 'Terminated'), _contractStatusLabels);
exports.contractStatusLabels = contractStatusLabels;
var contractStatusBadges = (_contractStatusBadges = {}, (0, _defineProperty2["default"])(_contractStatusBadges, contractStatus.BOTH_PARTIES_SIGNED, 'active'), (0, _defineProperty2["default"])(_contractStatusBadges, contractStatus.DECLINED, 'inactive'), (0, _defineProperty2["default"])(_contractStatusBadges, contractStatus.EMPLOYEE_SIGNED, 'pending'), (0, _defineProperty2["default"])(_contractStatusBadges, contractStatus.EMPLOYER_SIGNED, 'pending'), (0, _defineProperty2["default"])(_contractStatusBadges, contractStatus.ISSUED, 'pending'), (0, _defineProperty2["default"])(_contractStatusBadges, contractStatus.PENDING_EMPLOYEE_SIGNATURE, 'pending'), (0, _defineProperty2["default"])(_contractStatusBadges, contractStatus.PENDING_EMPLOYER_SIGNATURE, 'pending'), (0, _defineProperty2["default"])(_contractStatusBadges, contractStatus.TERMINATED, 'inactive'), _contractStatusBadges);
exports.contractStatusBadges = contractStatusBadges;
var contractStatusOptions = [{
  value: contractStatus.BOTH_PARTIES_SIGNED,
  label: 'Signed'
}, {
  value: contractStatus.DECLINED,
  label: 'Declined'
}, {
  value: contractStatus.EMPLOYEE_SIGNED,
  label: 'Signed by employee'
}, {
  value: contractStatus.EMPLOYER_SIGNED,
  label: 'Signed by customer'
}, {
  value: contractStatus.ISSUED,
  label: 'Awaiting signatures'
}, {
  value: contractStatus.PENDING_EMPLOYEE_SIGNATURE,
  label: 'Waiting for employee to sign'
}, {
  value: contractStatus.PENDING_EMPLOYER_SIGNATURE,
  label: 'Waiting for customer to sign'
}, {
  value: contractStatus.TERMINATED,
  label: 'Terminated'
}];
exports.contractStatusOptions = contractStatusOptions;
var compensationStatus = {
  ACTIVE: 'active'
};
exports.compensationStatus = compensationStatus;
var compensationPeriodicity = {
  ANNUALLY: 'annually',
  MONTHLY: 'monthly'
};
exports.compensationPeriodicity = compensationPeriodicity;
var noSalarySetLabel = 'Salary not set'; // - - - - - - - - -

exports.noSalarySetLabel = noSalarySetLabel;
var terminationReason = {
  DECEASED: 'deceased',
  DISMISSED: 'dismissed',
  END_OF_CONTRACT: 'end_of_contract',
  REDUNDANCY: 'redundancy',
  RESIGNED: 'resigned',
  RETIREMENT: 'retirement',
  TRANSFERRED: 'transferred',
  UNKNOWN: 'unknown'
};
exports.terminationReason = terminationReason;
var terminationReasonLabels = (_terminationReasonLab = {}, (0, _defineProperty2["default"])(_terminationReasonLab, terminationReason.DECEASED, 'Deceased'), (0, _defineProperty2["default"])(_terminationReasonLab, terminationReason.DISMISSED, 'Dismissed'), (0, _defineProperty2["default"])(_terminationReasonLab, terminationReason.END_OF_CONTRACT, 'End of contract'), (0, _defineProperty2["default"])(_terminationReasonLab, terminationReason.REDUNDANCY, 'Redundancy'), (0, _defineProperty2["default"])(_terminationReasonLab, terminationReason.RESIGNED, 'Resigned'), (0, _defineProperty2["default"])(_terminationReasonLab, terminationReason.RETIREMENT, 'Retirement'), (0, _defineProperty2["default"])(_terminationReasonLab, terminationReason.TRANSFERRED, 'Transferred'), (0, _defineProperty2["default"])(_terminationReasonLab, terminationReason.UNKNOWN, 'Unknown'), _terminationReasonLab);
exports.terminationReasonLabels = terminationReasonLabels;
var terminationReasonOptions = Object.keys(terminationReasonLabels).map(function (value) {
  return {
    value: value,
    label: terminationReasonLabels[value]
  };
});
exports.terminationReasonOptions = terminationReasonOptions;
var IR35_STATUSES = {
  INSIDE: {
    label: 'Inside IR35 (deemed employee)',
    value: 'inside'
  },
  OUTSIDE: {
    label: 'Outside IR35',
    value: 'outside'
  },
  EXEMPT: {
    label: 'Exempt from IR35',
    value: 'exempt'
  }
};
exports.IR35_STATUSES = IR35_STATUSES;
var IR35_FILE_SUBTYPE = 'ir_35';
exports.IR35_FILE_SUBTYPE = IR35_FILE_SUBTYPE;